module.exports = __webpack_public_path__ + "img/gkzk.9f71c52b.png";